import { ADD_CANDIDATE_INFO, ADD_BASIC_INFO, RESET_REGISTER } from "./actions";

const initialState = {
  registeredData: {
    info: {
      source: "",
      college: "",
      course:'',
      degree: "",
      year: "",
      courseType:'',
      income: "",
      family: "",
      indian: "",
      aadhaar: "",
      mobile: "",
      email: "",
      password: "",
      arn:'',
      isDob: false,
    },
    basicInfo:{}
  },
};

const RegistrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CANDIDATE_INFO:
      let data = state.registeredData;
      console.log("in reducer", action.data[0],  action.data[1]);
      if(data?.info){
      data.info[action.data[0]] = action.data[1];
      }
      return {
        ...state,
        registeredData: { ...data },
      };
  
      case ADD_BASIC_INFO:
      let data2 = state.registeredData;
      // if(data2?.basicInfo){
        data2.basicInfo = {...action.data};
        console.log('data2', data2, action.data)
      // }
      return {
        ...state,
        registeredData: { ...data2 },
      };
  case RESET_REGISTER:
    return initialState;
    default:
      return state;
  }
};
export default RegistrationReducer;
